document.addEventListener('alpine:init', () => {
	Alpine.data('sc_fab', () => ({
		hidden: false,
		lastY: 0,

		onScroll() {
			const curr = window.pageYOffset || document.documentElement.scrollTop;
			if (curr > this.lastY && curr > 60) {
				this.hidden = true;
			} else if (curr < this.lastY || curr <= 60) {
				this.hidden = false;
			}
			this.lastY = curr <= 0 ? 0 : curr;
		},
	}));
});
